import React, { useState, useEffect, useCallback } from "react"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { toast, ToastContainer } from "react-toastify"
import logo from "../../assets/images/logo.png"
import { useHistory } from "react-router-dom"
import { Link } from "react-router-dom"
import debounce from "lodash/debounce"
import Dropzone from "react-dropzone"
import Select from "react-select"
import { URLS } from "../../Url"
import axios from "axios"
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormGroup,
} from "reactstrap"

function AddDeal() {
  const [form, setForm] = useState({
    name: "",
    dealcategoryId: "",
    priorityId: "",
    fromDate: "",
    toDate: "",
    quantity: "",
    applyFor: "",
  })

  const [selectedFiles, setSelectedFiles] = useState([])
  const [price, setPrice] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const history = useHistory()
  const [priority, setPriority] = useState([])
  const [categories, setCategories] = useState([])
  const [cities, setCities] = useState([])
  const [selectedCityOptions, setSelectedCityOptions] = useState([])
  const [labels, setLabels] = useState("")

  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = JSON.parse(GetAuth)
  const token = TokenJson?.token || ""

  const fetchCities = useCallback(
    debounce(async Id => {
      try {
        const response = await axios.post(
          URLS.DealPriorityLocations,
          { purchaseId: Id },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setCities(response.data.data?.values || [])
        setLabels(response.data.data?.label || "")
      } catch (error) {
        console.error("Fetch cities error:", error)
        toast.error("Failed to fetch cities")
      }
    }, 300),
    [token]
  )

  const getCategories = useCallback(async () => {
    try {
      const res = await axios.post(
        URLS.GetDealCategory,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setCategories(res.data.dealcategorys || [])
    } catch (error) {
      toast.error("Failed to fetch categories")
      console.error("Category fetch error:", error)
    }
  }, [token])

  const cityOptions =
    cities?.map(id => ({
      value: id.id,
      label: id.name,
    })) || []

  const handleCitySelect = selectedOptions => {
    setSelectedCityOptions(selectedOptions || [])
  }

  const handleChange = e => {
    const { name, value } = e.target
    setForm(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleChanges = e => {
    const { name, value } = e.target
    setForm(prev => ({
      ...prev,
      [name]: value,
    }))
    if (name === "priorityId" && value) {
      fetchCities(value)

      const selectedPriority = priority.find(p => p._id === value)
      if (selectedPriority) {
        setPrice(selectedPriority.price)
      }
    }
    setCities([])
    setSelectedCityOptions([])
    setLabels("")
  }

  const handleCategoryChange = async e => {
    const { value } = e.target
    setForm(prev => ({
      ...prev,
      dealcategoryId: value,
      priorityId: "",
    }))
    setPriority([])
    setCities([])
    setSelectedCityOptions([])
    setLabels("")
    setPrice("")

    if (value) {
      try {
        const response = await axios.post(
          URLS.GetDealByPriority,
          { dealcategoryId: value },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setPriority(response.data.data || [])
      } catch (error) {
        toast.error("Failed to fetch priorities")
        console.error("Priority fetch error:", error)
      }
    }
  }

  const validateForm = () => {
    if (!form.name) {
      toast.error("Name is required")
      return false
    }
    if (!form.dealcategoryId) {
      toast.error("Category is required")
      return false
    }
    if (!form.priorityId) {
      toast.error("Priority is required")
      return false
    }
    if (!form.quantity || form.quantity < 0 || form.quantity > 100) {
      toast.error("Quantity must be between 0 and 100")
      return false
    }
    if (!form.fromDate) {
      toast.error("Start date is required")
      return false
    }
    if (!form.toDate) {
      toast.error("End date is required")
      return false
    }
    if (new Date(form.toDate) < new Date(form.fromDate)) {
      toast.error("End date must be after start date")
      return false
    }
    if (!form.applyFor) {
      toast.error("Apply For is required")
      return false
    }
    if (form.applyFor === "deliverycity" && selectedCityOptions.length === 0) {
      toast.error("At least one city must be selected")
      return false
    }
    if (selectedFiles.length === 0) {
      toast.error("Image is required")
      return false
    }
    return true
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (!validateForm()) return
    setIsSubmitting(true)
    try {
      await addDeal()
    } catch (error) {
      console.error("Deal submission error:", error)
    } finally {
      setIsSubmitting(false)
    }
  }

  const authData = JSON.parse(localStorage.getItem("authUser") || "{}")
  const vendorDetails = authData?.vendor || {}

  const addDeal = async () => {
    const delieverIds = selectedCityOptions.map(option => option.value)
    const formData = new FormData()

    formData.append("applyFor", form.applyFor)
    formData.append("name", form.name)
    formData.append("quantity", form.quantity)
    formData.append("fromDate", form.fromDate)
    formData.append("toDate", form.toDate)
    formData.append("type", labels)
    formData.append("priorityId", form.priorityId)
    formData.append("dealcategoryId", form.dealcategoryId)
    formData.append("delieverIds", JSON.stringify(delieverIds))

    for (let i = 0; i < selectedFiles.length; i++) {
      formData.append("image", selectedFiles[i])
    }

    try {
      const res = await axios.post(URLS.AddDeal, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })

      if (res.status === 200) {
        toast.success(res.data.message)
        handlePayment(res.data.dealId)
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(error.response.data.message)
        } else {
          toast.error("An error occurred while adding the deal")
        }
      } else {
        toast.error("Network error - please try again")
      }
      throw error
    }
  }

  const handlePayment = data => {
    const totals = parseInt(price) * 100
    const options = {
      key: "rzp_test_HJG5Rtuy8Xh2NB",
      amount: totals,
      currency: "INR",
      name: "Bizzmate",
      description: "Bizzmate Transaction",
      image: logo,
      handler: async function (response) {
        try {
          const paymentResponse = await axios.post(
            URLS.AddDealPayment,
            {
              dealId: data,
              paymentStatus: "completed",
              transactionId: response.razorpay_payment_id,
              amount: price,
              status: "active",
            },
            { headers: { Authorization: `Bearer ${token}` } }
          )

          if (paymentResponse.status === 200) {
            toast.success(paymentResponse.data.message)
            history.push("/Deals")
          }
        } catch (error) {
          console.error("Payment processing error:", error)
          toast.error("Failed to process payment")
        }
      },
      prefill: {
        name: `${vendorDetails.firstName || ""} ${
          vendorDetails.lastName || ""
        }`,
        email: vendorDetails.email || "",
        contact: vendorDetails.sellerMobile || "",
      },
      theme: {
        color: "#00578E",
      },
    }

    const rzp1 = new window.Razorpay(options)
    rzp1.open()
  }

  const handleAcceptedFiles = files => {
    if (files.length === 0) return

    // Revoke existing previews synchronously
    selectedFiles.forEach(file => {
      if (file.preview) URL.revokeObjectURL(file.preview)
    })

    const file = files[0]
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    })

    setSelectedFiles([file])
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  useEffect(() => {
    getCategories()
  }, [getCategories])

  useEffect(() => {
    return () => {
      selectedFiles.forEach(file => {
        if (file.preview) URL.revokeObjectURL(file.preview)
      })
    }
  }, [selectedFiles])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="Create Deal" />
          <Form onSubmit={handleSubmit}>
            <Card>
              <CardBody>
                <Row>
                  <Col xl="12">
                    <Button
                      onClick={() => history.goBack()}
                      className="mb-2"
                      style={{ float: "right" }}
                      color="primary"
                      type="button"
                      size="sm"
                    >
                      <i className="far fa-arrow-alt-circle-left me-1"></i>
                      Back
                    </Button>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col lg="8">
                    <div className="mb-3">
                      <Label htmlFor="deal-name-input">
                        Name <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="deal-name-input"
                        placeholder="Enter Name"
                        required
                        value={form.name}
                        name="name"
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="deal-category-select">
                        Deal Category Name
                      </Label>
                      <span className="text-danger">*</span>
                      <Input
                        type="select"
                        value={form.dealcategoryId}
                        name="dealcategoryId"
                        required
                        onChange={handleCategoryChange}
                        className="form-select"
                        id="deal-category-select"
                      >
                        <option value="">Select</option>
                        {categories.map(data => (
                          <option key={data._id} value={data._id}>
                            {data.name}
                          </option>
                        ))}
                      </Input>
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="priority-select">Priority</Label>
                      <span className="text-danger">*</span>
                      <Input
                        type="select"
                        value={form.priorityId}
                        name="priorityId"
                        required
                        onChange={handleChanges}
                        className="form-select"
                        id="priority-select"
                        disabled={!form.dealcategoryId}
                      >
                        <option value="">Select</option>
                        {priority.map(data => (
                          <option key={data._id} value={data._id}>
                            Priority: {data.priority}, Customer Reach:{" "}
                            {data.CustomerReach}, Price: {data.price}/-
                          </option>
                        ))}
                      </Input>
                    </div>

                    {/* Price Display Section */}
                    {price && (
                      <div className="mb-3">
                        <Label htmlFor="price-display">
                          Deal Price <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="text"
                          className="form-control bg-light"
                          id="price-display"
                          value={`₹ ${price}`}
                          readOnly
                          style={{ fontWeight: "bold", fontSize: "16px" }}
                        />
                        <small className="text-muted">
                          This is the amount you'll be charged for creating this
                          deal
                        </small>
                      </div>
                    )}

                    <div className="mb-3">
                      <Label htmlFor="quantity-input">
                        Quantity <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="number"
                        className="form-control"
                        id="quantity-input"
                        placeholder="Enter Quantity"
                        required
                        value={form.quantity}
                        name="quantity"
                        onChange={handleChange}
                        min="0"
                        max="100"
                      />
                    </div>
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="start-date-input">
                            Start Date <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="date"
                            className="form-control"
                            id="start-date-input"
                            placeholder="Enter Start Date"
                            required
                            value={form.fromDate}
                            name="fromDate"
                            onChange={handleChange}
                            min={new Date().toISOString().split("T")[0]}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="end-date-input">
                            End Date
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="date"
                            className="form-control"
                            id="end-date-input"
                            placeholder="Enter End Date"
                            required
                            value={form.toDate}
                            name="toDate"
                            onChange={handleChange}
                            min={
                              form.fromDate ||
                              new Date().toISOString().split("T")[0]
                            }
                          />
                        </div>
                      </Col>
                      <Col md="12">
                        <FormGroup>
                          <Label htmlFor="apply-for-select">Apply For </Label>
                          <span className="text-danger">*</span>
                          <Input
                            type="select"
                            name="applyFor"
                            value={form.applyFor}
                            onChange={handleChange}
                            required
                            id="apply-for-select"
                          >
                            <option value="">Select applyFor</option>
                            <option value="deliverycity">
                              Delivery {labels}
                            </option>
                            <option value="customer">Customers</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      {form.applyFor === "deliverycity" && (
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="city-select">
                              {labels}
                              <span className="text-danger">*</span>
                            </Label>
                            <Select
                              id="city-select"
                              placeholder="Select"
                              value={selectedCityOptions}
                              options={cityOptions}
                              isSearchable={true}
                              onChange={handleCitySelect}
                              isMulti
                              aria-label="Select cities"
                            />
                          </FormGroup>
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col lg="4" className="mb-4">
                    <div className="m-2">
                      <h5 style={{ fontWeight: "bold" }}>
                        Thumbnail Ratio 3:2 (400 x 400 px)
                      </h5>
                      <div className="w-100">
                        <Dropzone
                          onDrop={handleAcceptedFiles}
                          accept="image/*"
                          maxFiles={1}
                          aria-label="Upload deal thumbnail"
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div className="dropzone" {...getRootProps()}>
                              <input {...getInputProps()} />
                              <div className="dz-message needsclick mt-2">
                                <div className="mb-3">
                                  <i className="display-4 text-muted bx bxs-cloud-upload" />
                                </div>
                                <h4>Upload File</h4>
                              </div>
                            </div>
                          )}
                        </Dropzone>
                        <div
                          className="dropzone-previews mt-3"
                          id="file-previews"
                        >
                          {selectedFiles.map((f, i) => (
                            <Card
                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                              key={i + "-file"}
                            >
                              <div className="p-2">
                                <Row className="align-items-center">
                                  <Col className="col-auto">
                                    <img
                                      data-dz-thumbnail=""
                                      height="40"
                                      className="avatar-sm rounded bg-light"
                                      alt={f.name}
                                      src={f.preview}
                                    />
                                  </Col>
                                  <Col>
                                    <Link
                                      to="#"
                                      className="text-muted font-weight-bold"
                                    >
                                      {f.name}
                                    </Link>
                                    <p className="mb-0">
                                      <strong>{f.formattedSize}</strong>
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            </Card>
                          ))}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="mb-2" style={{ float: "right" }}>
                      <Button
                        type="submit"
                        style={{ width: "120px" }}
                        color="primary"
                        className="m-1 btn-sm"
                        disabled={isSubmitting || !price}
                      >
                        {isSubmitting ? (
                          <>
                            Submitting...{" "}
                            <i className="fas fa-spinner fa-spin"></i>
                          </>
                        ) : (
                          <>
                            Pay ₹{price || "0"}{" "}
                            <i className="fas fa-check-circle ms-1"></i>
                          </>
                        )}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Form>
        </Container>
        <ToastContainer />
      </div>
    </React.Fragment>
  )
}

export default AddDeal
